import { useContext } from 'react'
import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Switch, Text } from '@reveni-io/reveni-ui'

import { availableLanguagesForUser } from '@/common/constants'
import AppContext from '@/common/context/app.context'
import LanguageRichTextInput from '@/configuration/components/LanguageRichTextInput/LanguageRichTextInput'

import * as Styles from './styles'

const BrokenDiscountCustomMessage = ({ enabled, message, onChangeEnabled, onChangeMessage, disabled }) => {
  const theme = useTheme()
  const { info } = useContext(AppContext)
  const { t } = useTranslation()
  const supportedLanguages = info?.selectedStore?.supported_languages || ['en']
  const languages = availableLanguagesForUser.filter(lang => supportedLanguages.includes(lang))

  const handleToggleEnabled = e => {
    onChangeEnabled(e.target.checked)
  }

  const handleChangeMessage = (value, language) => {
    onChangeMessage({ ...message, [language]: value })
  }

  return (
    <Styles.Container>
      <Text type="titleS">{t('Mensaje personalizado')}</Text>
      <Switch
        checked={enabled}
        onChange={handleToggleEnabled}
        label={t('Mostrar mensaje personalizado')}
        disabled={disabled}
      />
      {enabled && (
        <LanguageRichTextInput
          languages={languages}
          value={message}
          onChange={handleChangeMessage}
          inputLabel={t('Mensaje personalizado')}
          helperText={t('Este campo es obligatorio')}
          showInputError
          backgroundColor={theme.colors.background.primary}
          disabled={disabled}
        />
      )}
    </Styles.Container>
  )
}

export default BrokenDiscountCustomMessage
